import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionLabel } from './ui/SectionLabel';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'SECURE THE PERIMETER',
    desc: 'Audit your environment and implement the "Nasal Gating" and "Mitochondrial Priming" daily rituals.'
  }, {
    num: '02',
    title: 'FORTIFY THE INNER GUARD',
    desc: 'Use the specific TCM herbal stacks to close the "dampness" gaps in your gut and respiratory lining.'
  }, {
    num: '03',
    title: 'EXECUTE RAPID RESPONSE',
    desc: 'At the first "tickle" or signal, deploy the 72-hour protocol to flush the system and prevent docking.'
  }];
  return <section className="py-24 bg-bio-black" data-id="element-174">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-175">
        <FadeIn data-id="element-176">
          <SectionLabel text="EXECUTION // STANDARD OPERATING PROCEDURE" data-id="element-177" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-16" data-id="element-178">
            HOW IT WORKS
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-179">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-[1px] bg-bio-gray/50 z-0" data-id="element-180">
            <div className="absolute top-0 left-0 h-full w-1/3 bg-gradient-to-r from-bio-teal to-transparent opacity-50" data-id="element-181" />
          </div>

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-182">
            {steps.map((step, i) => <FadeIn key={i} delay={i * 0.2} data-id="element-183">
                <div className="relative" data-id="element-184">
                  <div className="w-24 h-24 bg-bio-dark border border-bio-teal/30 flex items-center justify-center mb-8 mx-auto md:mx-0 relative group" data-id="element-185">
                    <div className="absolute inset-0 bg-bio-teal/5 group-hover:bg-bio-teal/10 transition-colors" data-id="element-186" />
                    <span className="font-mono text-3xl text-bio-teal font-bold" data-id="element-187">
                      {step.num}
                    </span>

                    {/* Decorative nodes */}
                    <div className="absolute -left-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-bio-black border border-bio-teal" data-id="element-188" />
                    <div className="absolute -right-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-bio-black border border-bio-teal" data-id="element-189" />
                  </div>

                  <h3 className="text-xl font-bold text-white mb-4 text-center md:text-left tracking-wide" data-id="element-190">
                    {step.title}
                  </h3>
                  <p className="text-bio-muted font-light text-center md:text-left leading-relaxed" data-id="element-191">
                    {step.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}